var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      attrs: {
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        clearable: "",
        filterable: "",
      },
      model: {
        value: _vm.mySelectedValue,
        callback: function ($$v) {
          _vm.mySelectedValue = $$v
        },
        expression: "mySelectedValue",
      },
    },
    _vm._l(_vm.Option, function (option) {
      return _c("el-option", {
        key: option.value,
        attrs: { label: option.name, value: option.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }